import account from "../../images/icons/basic/account.svg";
import character from "../../images/icons/basic/character.svg";
import circleCancel from "../../images/icons/basic/circle-cancel.svg";
import chevron from "../../images/icons/basic/chevron-down-solid.svg";
import close from "../../images/icons/basic/close.svg";
import circleChecked from "../../images/icons/basic/circle-checked.svg";
import copy from "../../images/icons/basic/copy.svg";
import ellipsis from "../../images/icons/basic/ellipsis-vertical.svg";
import exchange from "../../images/icons/basic/exchange.svg";
import externalLink from "../../images/icons/basic/external-link.svg";
import eye from "../../images/icons/basic/eye-solid.svg";
import eyeOpen from "../../images/icons/basic/eye-open.svg";
import eyeClosed from "../../images/icons/basic/eye-closed.svg";
import grip from "../../images/icons/basic/grip-lines.svg";
import hourglass from "../../images/icons/basic/hourglass.svg";
import image from "../../images/icons/basic/image-solid.svg";
import language from "../../images/icons/basic/language.svg";
import minus from "../../images/icons/basic/minus.svg";
import padlock from "../../images/icons/basic/padlock.svg";
import pawn from "../../images/icons/basic/pawn.svg";
import payMoney from "../../images/icons/basic/pay-money.svg";
import previous from "../../images/icons/basic/previous.svg";
import pen from "../../images/icons/basic/pen.svg";
import play from "../../images/icons/basic/play.svg";
import plus from "../../images/icons/basic/plus.svg";
import replace from "../../images/icons/basic/replace.svg";
import reset from "../../images/icons/basic/reset.svg";
import roundStar from "../../images/icons/basic/round-star.svg";
import search from "../../images/icons/basic/search.svg";
import sheet from "../../images/icons/basic/sheet.svg";
import share from "../../images/icons/basic/share.svg";
import soundLevel from "../../images/icons/basic/sound-level.svg";
import soundOff from "../../images/icons/basic/sound-off.svg";
import team from "../../images/icons/basic/team.svg";
import transfer from "../../images/icons/basic/transfer.svg";
import trash from "../../images/icons/basic/trash-can.svg";
import upArrow from "../../images/icons/basic/up-arrow-2.svg";
import warning from "../../images/icons/basic/warning-sign.svg";
import carisma from "../../images/icons/attributes/carisma.svg";
import constituicao from "../../images/icons/attributes/constituicao.svg";
import destreza from "../../images/icons/attributes/destreza.svg";
import forca from "../../images/icons/attributes/forca.svg";
import inteligencia from "../../images/icons/attributes/inteligencia.svg";
import sabedoria from "../../images/icons/attributes/sabedoria.svg";
import dice20 from "../../images/icons/dice/black20.svg";
import alignmentCaotico from "../../images/icons/rpg/alignments/caotico.svg";
import alignmentNeutro from "../../images/icons/rpg/alignments/neutro.svg";
import alignmentOrdeiro from "../../images/icons/rpg/alignments/ordeiro.svg";
import wings from "../../images/icons/rpg/angel-wings.svg";
import ammunition from "../../images/icons/rpg/ammunition.svg";
import anvil from "../../images/icons/rpg/anvil.svg";
import backpack from "../../images/icons/rpg/backpack.svg";
import book from "../../images/icons/rpg/book.svg";
import bludgeoning from "../../images/icons/rpg/bludgeoning.svg";
import campfire from "../../images/icons/rpg/campfire.svg";
import cauldron from "../../images/icons/rpg/cauldron.svg";
import klass from "../../images/icons/rpg/character-class.svg";
import race from "../../images/icons/rpg/character-race.svg";
import mapas from "../../images/icons/rpg/campaign.svg";
import coins from "../../images/icons/rpg/coins.svg";
import dramaMasks from "../../images/icons/rpg/drama-masks.svg";
import dmShield from "../../images/icons/rpg/dm-shield.svg";
import heart from "../../images/icons/rpg/heart.svg";
import heartInside from "../../images/icons/rpg/heart-inside.svg";
import heartMinus from "../../images/icons/rpg/heart-minus.svg";
import heartPlus from "../../images/icons/rpg/heart-plus.svg";
import identity from "../../images/icons/rpg/identity.svg";
import infravision from "../../images/icons/rpg/infravision.svg";
import levelUp from "../../images/icons/rpg/level-up.svg";
import magicItem from "../../images/icons/rpg/magic-item.svg";
import melee from "../../images/icons/rpg/melee.svg";
import mirror from "../../images/icons/rpg/mirror.svg";
import movement from "../../images/icons/rpg/movement.svg";
import naturalWeapon from "../../images/icons/rpg/natural_weapon.svg";
import piercing from "../../images/icons/rpg/piercing.svg";
import ranged from "../../images/icons/rpg/ranged.svg";
import rollingDices from "../../images/icons/rpg/rolling-dices.svg";
import scroll from "../../images/icons/rpg/scroll-quill.svg";
import grimoire from "../../images/icons/rpg/secret-book.svg";
import shieldFull from "../../images/icons/rpg/shield-full.svg";
import shieldHalf from "../../images/icons/rpg/shield-half.svg";
import slashing from "../../images/icons/rpg/slashing.svg";
import skull from "../../images/icons/rpg/skull-crossed-bones.svg";
import sparkles from "../../images/icons/rpg/sparkles.svg";
import spellBook from "../../images/icons/rpg/spell-book.svg";
import throwing from "../../images/icons/rpg/throwing.svg";
import twoHanded from "../../images/icons/rpg/two_handed.svg";
import unarmed from "../../images/icons/rpg/unarmed.svg";
import weaponMastery from "../../images/icons/rpg/weapon-mastery.svg";

const ICONS = {
	account,
	mapas,
	ammunition,
	anvil,
	bludgeoning,
	backpack,
	book,
	character,
	circleCancel,
	circleChecked,
	chevron,
	copy,
	ellipsis,
	exchange,
	externalLink,
	eye,
	eyeClosed,
	eyeOpen,
	grip,
	identity,
	sheet,
	share,
	soundLevel,
	soundOff,
	carisma,
	constituicao,
	destreza,
	forca,
	inteligencia,
	sabedoria,
	campfire,
	cauldron,
	dramaMasks,
	dice20,
	dmShield,
	rollingDices,
	close,
	race,
	class: klass,
	coins,
	heart,
	heartInside,
	heartMinus,
	heartPlus,
	infravision,
	levelUp,
	magicItem,
	melee,
	mirror,
	movement,
	naturalWeapon,
	piercing,
	ranged,
	scroll,
	grimoire,
	shieldFull,
	shieldHalf,
	weaponMastery,
	skull,
	sparkles,
	slashing,
	throwing,
	twoHanded,
	unarmed,
	wings,
	alignmentCaotico,
	alignmentNeutro,
	alignmentOrdeiro,
	hourglass,
	image,
	language,
	minus,
	padlock,
	pawn,
	payMoney,
	pen,
	play,
	plus,
	previous,
	replace,
	reset,
	roundStar,
	search,
	spellBook,
	team,
	transfer,
	trash,
	upArrow,
	warning,
};

const CONCEPTS = import.meta.glob("../../images/icons/equipment/concept-*.svg", { eager: true, query: "?url", import: "default" }) as Record<string, string>;
const MONSTER_CONCEPTS = import.meta.glob("../../images/icons/monsters/concepts/*.svg", { eager: true, query: "?url", import: "default" }) as Record<
	string,
	string
>;
const TALENTS = import.meta.glob("../../images/icons/rogue_talents/*.svg", { eager: true, query: "?url", import: "default" }) as Record<string, string>;

const SOUNDS = import.meta.glob("../../images/icons/sound/*.svg", { eager: true, query: "?url", import: "default" }) as Record<string, string>;

export type IconName = keyof typeof ICONS;

export const ICON_NAMES = Object.keys(ICONS) as IconName[];

// The icon files are tinted with the text colour through a mask, so they follow both themes.
export function MaskIcon({ url, class: className = "h-4 w-4" }: { url: string; class?: string }) {
	const mask = `url("${url}") center / contain no-repeat`;
	return <span aria-hidden="true" class={`inline-block shrink-0 bg-current ${className}`} style={{ mask, WebkitMask: mask }} />;
}

export function Icon({ name, class: className }: { name: IconName; class?: string }) {
	return <MaskIcon url={ICONS[name]} class={className} />;
}

export function talentIconUrl(key: string): string | undefined {
	return TALENTS[`../../images/icons/rogue_talents/${key}.svg`];
}

export function soundIconUrl(slug: string): string | undefined {
	return SOUNDS[`../../images/icons/sound/${slug}.svg`];
}

export function conceptIconUrl(concept: string): string | undefined {
	return CONCEPTS[`../../images/icons/equipment/concept-${concept}.svg`];
}

export function monsterConceptIconUrl(concept: string): string | undefined {
	return MONSTER_CONCEPTS[`../../images/icons/monsters/concepts/${concept}.svg`];
}

export function isIconName(name: string): name is IconName {
	return name in ICONS;
}
